var render = function render() {
  var _vm$store$statusSelec, _vm$store$statusSelec2;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3",
    attrs: {
      "align-h": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Importa somente orçamentos com status: Autorizado',
      expression: "\n            'Importa somente orçamentos com status: Autorizado'\n          ",
      modifiers: {
        "top": true
      }
    }],
    ref: "import-orcamento-button",
    staticClass: "btn btn-primary font-weight-bold mr-2",
    staticStyle: {
      "height": "38px"
    },
    on: {
      "click": _vm.buscarOrcamentos
    }
  }, [_vm._v(" Importar Orçamento ")])])], 1), _c('b-card', [_c('b-tabs', {
    attrs: {
      "pills": "",
      "horizontal": _vm.windowWidth < 768,
      "vertical": _vm.windowWidth > 768,
      "nav-wrapper-class": _vm.windowWidth > 768 ? 'w-25' : 'w-100',
      "fill": ""
    }
  }, [_c('DadosGerais'), _c('Objeto'), _c('Problema'), _c('Produto'), _c('Servicos'), _c('Pagamento'), _c('Observacoes'), _c('Anexos')], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveOrdem ? _c('div', [_c('div', {
    staticClass: "form mb-5"
  }, [!_vm.store.isUpdate ? _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Selecionar status da OS',
      expression: "'Selecionar status da OS'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('selecionarStatusOSModal');
      }
    }
  }, [_c('i', {
    staticClass: "flaticon2-checkmark mr-1"
  }), _vm._v(" Status: " + _vm._s(((_vm$store$statusSelec = _vm.store.statusSelecionado) === null || _vm$store$statusSelec === void 0 ? void 0 : _vm$store$statusSelec.descricao) || "Aberta") + " ")]) : _vm._e(), _vm.store.currentTab !== 0 ? _c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-2",
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]) : _vm._e(), _vm.store.isUpdate && _vm.store.currentTab !== 7 ? _c('button', {
    staticClass: "btn btn-primary font-weight-bold mr-4",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Próximo ")]) : _vm._e(), _c('button', {
    ref: "submit_nova_os",
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.salvarOrdemServico
    }
  }, [_vm._v(" Salvar ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('ordensServicos');
      }
    }
  }, [_vm._v(" Cancelar ")])])]) : _c('div', [!_vm.store.isUpdate ? _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Selecionar status da OS',
      expression: "'Selecionar status da OS'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "btn btn-light-primary font-weight-bold mr-2",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.show('selecionarStatusOSModal');
      }
    }
  }, [_c('i', {
    staticClass: "flaticon2-checkmark mr-1"
  }), _vm._v(" Status: " + _vm._s(((_vm$store$statusSelec2 = _vm.store.statusSelecionado) === null || _vm$store$statusSelec2 === void 0 ? void 0 : _vm$store$statusSelec2.descricao) || "Aberta") + " ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Próximo ")]), _c('button', {
    ref: "submit_previa_nfe",
    staticClass: "btn btn-clean font-weight-bold",
    on: {
      "click": function click($event) {
        return _vm.confirmCancel('ordensServicos');
      }
    }
  }, [_vm._v(" Cancelar ")])])])])])], 1), _c('b-modal', {
    attrs: {
      "id": "selecionarStatusOSModal",
      "title": "Selecionar status da OS",
      "centered": "",
      "size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Fechar ")])];
      }
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "statusOS"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatusOS",
    attrs: {
      "filterable": true,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.store.statusSelecionado,
      callback: function callback($$v) {
        _vm.$set(_vm.store, "statusSelecionado", $$v);
      },
      expression: "store.statusSelecionado"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Selecione o status ")])], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "importarOrcamentoOS",
      "title": "Importar Orçamento",
      "centered": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          ref: "importar_orcamento",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.importarOrcamento
          }
        }, [_vm._v(" Importar ")]), _c('b-button', {
          on: {
            "click": function click() {
              _vm.selectedOrcamento = null;
              cancel();
            }
          }
        }, [_vm._v(" Cancelar ")])];
      }
    }])
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', {
    attrs: {
      "align-h": "center"
    }
  }, [_c('b-col', [_c('b-form-group', {
    key: _vm.keyToReRender,
    attrs: {
      "label": "Orçamento"
    }
  }, [_c('VueSelect', {
    ref: "orcamento",
    attrs: {
      "filterable": false,
      "options": _vm.orcamentosToImport
    },
    on: {
      "search": _vm.onSearchOrcamento
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.numero) + " - " + _vm._s(option.cliente) + " ")])];
      }
    }]),
    model: {
      value: _vm.selectedOrcamento,
      callback: function callback($$v) {
        _vm.selectedOrcamento = $$v;
      },
      expression: "selectedOrcamento"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o orçamento")])], 2)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };